import React from 'react';

import './CardGallery.scss';
import ZoomableCard from '../Decks/ZoomableCard';
import CardModal from '../Decks/CardModal';
import CardImage from '../GameBoard/CardImage';

function CardGallery({ onAltClick = () => true, cards = [] }) {
    const cardList = cards;
    return (
        <div className='card-gallery'>
            {cardList.map((c) => (
                <div key={'alt' + (c.alt || c.imageStub)} onClick={() => onAltClick(c.id, c.alt)}>
                    <CardModal card={c}>
                        <CardImage card={c} noIndex={true} />
                    </CardModal>
                    {/* <ZoomableCard card={c} noIndex={true} /> */}
                </div>
            ))}
        </div>
    );
}

export default CardGallery;
